import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import CONSTANTS from "@/flit2go-web-core/interfaces/index";
import store from "@/flit2go-web-core/store/index";
import {
  DEVELOPERS,
  EMAIL,
  FAQS,
  INTEGRATIONS,
  LEGAL,
  ROLES,
  ROLES_TYPES,
  TAGS,
  BUDGETS_TERMS_AND_CONDITIONS,
  INVOICE_ISSUER,
  PAYMENT_METHODS,
} from "@/modules/Configuration/routesInterface";

const menu = {
  code: MODULE.CONFIGURATION.CODE,
  name: "configuration",
  label: "common.configuration",
  link: ROLES,
  children: [],
  createChildren: [],
};

const submenus = [
  {
    code: MODULE.CONFIGURATION.INTEGRATIONS,
    icon: "integration",
    label: "common.integrations",
    link: INTEGRATIONS,
    name: "integrations",
    tooltip: "common.integrations",
  },
  {
    code: MODULE.CONFIGURATION.FAQS,
    icon: "survey-1",
    name: "faqs",
    label: "common.faqs",
    link: FAQS,
    tooltip: "common.faqs",
  },
  {
    code: MODULE.CONFIGURATION.LEGAL,
    icon: "legal",
    name: "legal",
    label: "common.legal",
    link: LEGAL,
    tooltip: "common.legal",
  },
  {
    code: MODULE.CONFIGURATION.EMAIL,
    icon: "server",
    name: "email",
    label: "common.emailServer",
    link: EMAIL,
    tooltip: "common.emailServer",
  },
  {
    code: MODULE.CONFIGURATION.DEVELOPERS,
    icon: "developer",
    name: "developers",
    label: "common.developers",
    link: DEVELOPERS,
    tooltip: "common.developers",
  },
  {
    code: MODULE.CONFIGURATION.TAGS,
    icon: "tags",
    name: "tags",
    label: "common.tags",
    link: TAGS,
    tooltip: "common.tags",
  },
  {
    code: MODULE.CONFIGURATION.BUDGETS,
    icon: "budget",
    name: "budgets",
    label: "budgets",
    link: BUDGETS_TERMS_AND_CONDITIONS,
    tooltip: "budgets",
  },
  {
    code: MODULE.CONFIGURATION.BILLING,
    icon: "upload-list",
    name: "billing",
    label: "common.billing",
    link: INVOICE_ISSUER,
    tooltip: "common.billing",
  },
  {
    code: MODULE.CONFIGURATION.PAYMENT_METHODS,
    icon: "credit-card",
    name: "paymentMethods",
    label: "paymentMethods",
    link: PAYMENT_METHODS,
    tooltip: "paymentMethods",
  },
];

function getMenu(submodules) {
  const isSuperOwner = store.getters["auth/isSuperOwner"];
  const isAggregator = store.getters["auth/isAggregator"];
  const isDealer = store.getters["auth/isOwnerDealer"];
  const isPremium = store.getters["auth/isOwnerPremium"];
  checkSuperOwnerMenu(isSuperOwner, isAggregator);
  menu.children = [];
  const isExternalBilling =
    CONSTANTS.OWNER.BILLING_TYPE.EXTERNAL ===
    store.getters["auth/user"].billing.billingType.code;

  submodules.forEach((submodule) => {
    if (submodule.code !== MODULE.CONFIGURATION.BILLING || isExternalBilling) {
      const submenuAux = submenus.find(
        (submenu) => submenu.code === submodule.code,
      );
      if (submenuAux && (submodule.r || submodule.w)) {
        if (
          submenuAux.code === MODULE.CONFIGURATION.FAQS ||
          submenuAux.code === MODULE.CONFIGURATION.LEGAL ||
          submenuAux.code === MODULE.CONFIGURATION.EMAIL
        ) {
          if (isDealer || isPremium) {
            menu.children.push(submenuAux);
          }
        } else {
          menu.children.push(submenuAux);
        }
      }
    }
  });
  return menu;
}

function checkSuperOwnerMenu(isSuperOwner, isAggregator) {
  submenus.splice(1, 0, {
    code: MODULE.CONFIGURATION.ROLES_PERMISSIONS,
    icon: "user-gear",
    label: "common.rolesAuthorities",
    link: isSuperOwner && !isAggregator ? ROLES_TYPES : ROLES,
    name: "roles",
    tooltip: "common.rolesAuthorities",
  });
}

export default { getMenu };
